<script lang="ts">
	import { getContext } from 'svelte';

	import { fade } from 'svelte/transition';
	import type { FlowContainerContext } from '../../types/FlowContainerTypes';
	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();

	let { currentPage, registerPage } = getContext<FlowContainerContext>('enzianFlowContainer');

	//@ts-ignore
	let pageNumber = registerPage(this);
</script>

{#if pageNumber === $currentPage}
	<div class="h-full overflow-y-auto" in:fade={{ duration: 400 }}>
		{@render children?.()}
	</div>
{/if}
